/// <reference path="../Campaignresult/CampaignresultGrid.ts" />

namespace Nobox.Nobox {

    import fld = CampaignresultRow.Fields;

    @Serenity.Decorators.registerClass()
    export class CampaignCampaignResultGrid extends CampaignresultGrid {
        protected getDialogType() { return CampaignresultDialog; }
        protected getColumnsKey() { return CampaignCampaignResultColumns.columnsKey; }

        constructor(container: JQuery) {
            super(container);
            this.element.find(".delete-all-messages").toggle(true);
            this.element.find(".failed-to-queue").toggle(true);
            this.deleteFun = () => {
                Q.serviceCall({
                    blockUI: false,
                    url: "/Services/Nobox/Campaign/DeleteAllResult",
                    request: {
                        EntityId: this.campaignId
                    },
                    onSuccess: (res) => {
                        Q.notifySuccess(`Success delete Broadcast Messages`);
                        this.refresh();
                    },
                    onError: (err) => {
                        if (err == null || err == undefined) {

                        } else {
                            if (err.Error == null || err.Error == undefined) {

                            } else {
                                if (err.Error.Message == null || err.Error.Message == undefined) {

                                } else {
                                    Q.alert(err.Error.Message);
                                }
                            }
                        }
                    }
                })
            }
            this.fqFun = () => {
                Q.serviceCall({
                    blockUI: false,
                    url: "/Services/Nobox/Campaign/FailedToQueue",
                    request: {
                        EntityId: this.campaignId
                    },
                    onSuccess: (res) => {
                        Q.notifySuccess(`Success failed to queue`);
                        this.refresh();
                    },
                    onError: (err) => {
                        if (err == null || err == undefined) {

                        } else {
                            if (err.Error == null || err.Error == undefined) {

                            } else {
                                if (err.Error.Message == null || err.Error.Message == undefined) {

                                } else {
                                    Q.alert(err.Error.Message);
                                }
                            }
                        }
                    }
                })
            }
            this.hideButton("btn-generate", true);
            this.totalOnClick = () => {
                if (!Q.isEmptyOrNull(this.campaignId)) {
                    var dlg = new CampaignResultTotalDialog({
                        Id: this.campaignId
                    });
                    dlg.dialogOpen();
                }
            }
        }

        hideButton(cssClass, aktif) {
            this.element.find(`.${cssClass}`).first().toggle(aktif);
            this.element.find(`.${cssClass}`).first().parent().toggle(aktif);
        }

        protected initEntityDialog(itemType, dialog) {
            super.initEntityDialog(itemType, dialog);
            Serenity.SubDialogHelper.cascade(dialog, this.element.closest('.ui-dialog'));
        }

        protected addButtonClick() {
            this.editItem({ CampaignId: this.campaignId });
        }

        protected getInitialTitle() {
            return null;
        }

        protected getGridCanLoad() {
            return super.getGridCanLoad() && !!this.campaignId;
        }

        private _CampaignID: string;

        get campaignId() {
            return this._CampaignID;
        }
        set campaignId(value: string) {
            if (this._CampaignID !== value) {
                this._CampaignID = value;
                this.refresh();
            } else {
                this.refresh();
            }
        }
        protected onViewSubmit(): boolean {
            if (!super.onViewSubmit()) { return false; }
            let request = this.view.params as Serenity.ListRequest;
            request.EqualityFilter.CampaignId= this.campaignId;
            return true;
        }
    }
}